import { Component, ChangeDetectionStrategy, Input } from '@angular/core';
import { TuiSizeL, TuiSizeM, TuiSizeS } from '@taiga-ui/core';
import { ViewMode } from '@src/models';

/** TODO: не используется */
@Component({
  selector: 'app-field-text',
  templateUrl: './field-text.component.html',
  styleUrls: ['./field-text.component.scss', '../styles/field-content.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class FieldTextComponent {
  @Input() mode?: ViewMode = 'view';
  @Input() name?: string;
  @Input() value?: string | null;
  @Input() size: TuiSizeS | TuiSizeM | TuiSizeL = 'l';
}
